module.exports = __webpack_public_path__ + "img/beard-5.2bb0aa4a.svg";